import React from "react";
import Form from "../forms/form";
import { IoMdCheckmark } from "react-icons/io";
import { IoCloseSharp } from "react-icons/io5";
import MyCountdown from "../parts/countdown";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import FormatIcon from '../../img/themes-icon/format-icon.svg';
import PhoneIcon from '../../img/themes-icon/phone-icon.svg';
import EmailIcon from '../../img/themes-icon/email-icon.svg';
import LocIcon from '../../img/themes-icon/loc-icon.svg';

import SiteDecor from "../../img/site-decor.webp"


function Formats({ formatsData }) {

    const formatText = 'Формат участі';

    const formatsPhoneClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'formats_phone_click'
        });
    };

    const formatsEmailClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'formats_email_click'
        });
    };

    return (
        formatsData ?
            formatsData.map((item, index) => (
                <section className="formats mb-16 md:mb-32 overflow-hidden" key={index}>

                    <div className="container max-w-screen-xl mx-auto relative z-30 px-[15px]">

                        <div className="grid gap-14 md:grid-cols-2  mb-10 xl:mb-32">
                            <div>
                                <ScrollAnimation animateIn="animate__fadeInUp" animateOnce={true}>
                                    <h2 className="text-3xl text-center font-bold uppercase mb-9 md:text-left
                                        lg:text-[42px] lg:mb-14 xl:text-[50px]">{formatText}
                                    </h2>
                                </ScrollAnimation>
                                
                                {
                                    item.format.map((item, index) => (
                                        <div>
                                            <ScrollAnimation animateIn="animate__fadeInUp" animateOnce={true}>
                                                <ul>
                                                    {item.format_items.map((item, index) => (
                                                        <li className="flex gap-5 mb-3 last:mb-0" key={index}>
                                                            {item.forat_checkbox && (
                                                                <img
                                                                    src={FormatIcon}
                                                                    alt="icon"
                                                                    className="w-6 h-6 lg:w-7 lg:h-7"
                                                                />
                                                            )}
                                                            <span className="font-medium text-lg text-black">{item.forat_item}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </ScrollAnimation>
                                        </div>
                                    ))
                                }
                            </div>
                            <ScrollAnimation animateIn="animate__fadeInRight" animateOnce={true}>
                                <div className="py-14 px-[15px] -ml-[15px] -mr-[15px] md:ml-0 md:mr-0  lg:px-10 xl:px-16
                                    md:flex md:flex-col relative
                                    bg-[linear-gradient(27deg,_#009064_0%,_#46a37e_50.41%,_#e6e47c_100%)]">

                                    <div className="flex items-end gap-6 mb-5 text-white md:order-2">
                                        <p className="text-3xl">Івент закінчився</p>
                                        
                                        {/*    <div className="flex items-end gap-[6px] leading-none py-1 px-3 bg-white font-bold text-black">
                                                <span className="text-3xl">5000</span>
                                                <span className="text-[15px]">грн*</span>
                                            </div>
                                        <div>
                                            <p className="text-xs font-light">* Ціна до оподаткування</p>
                                        </div>
                                         <div>
                                            <div className="flex items-center gap-[6px] font-bold">
                                                <span className="relative text-3xl">5500
                                                    <span className="block absolute -left-[8px] top-1/2 -translate-y-1/2
                                                    w-[120%] h-[3px] bg-[#b43125] opacity-80 -rotate-6"></span>
                                                </span>
                                                <span className="text-[15px]">грн*</span>
                                            </div>
                                            <p className="text-xs font-light">* Ціна до оподаткування</p>
                                        </div> */}
                                    </div>
                                    {/*<div className="mb-7 text-white md:order-1">
                                        <MyCountdown />
                                    </div>*/}
                                    {/*<div className="md:order-3 text-white">
                                        <Form />
                                    </div>*/}

                                    <div className="absolute -right-[10%] -top-[10%] w-1/2">
                                        <img src={SiteDecor} alt="decor" className="w-full"/>
                                    </div>
                                </div>
                            </ScrollAnimation>
                        </div>

                        <div className="grid gap-16 md:grid-cols-2">
                            <div className="md:order-2">
                                <ScrollAnimation animateIn="animate__fadeInRight" animateOnce={true}>
                                    <div className="flex items-center gap-4 py-5 border-t-[1px] border-b-[1px] border-black lg:py-9">
                                        <div className="w-9 h-9 rounded-full flex items-center  justify-center flex-shrink-0  
                                            bg-[linear-gradient(127deg,_#009064_0%,_#46a37e_50.41%,_#e6e47c_100%)]">
                                            <img  src={PhoneIcon} alt="icon" className="w-[18px] h-[18px]"/>
                                        </div>
                                        <div>
                                            <p className="text-sm font-medium">Персональна консультація</p>
                                            <a href="tel:+380672230179" className="font-semibold text-[22px]" onClick={formatsPhoneClick}>+38 (067) 223 01 79</a>
                                        </div>
                                    </div>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInRight" animateOnce={true}>
                                    <div className="flex items-center gap-4 py-5 border-b-[1px] border-black lg:py-9">
                                        <div className="w-9 h-9 rounded-full flex items-center  justify-center flex-shrink-0
                                            bg-[linear-gradient(127deg,_#009064_0%,_#46a37e_50.41%,_#e6e47c_100%)]">
                                            <img  src={EmailIcon} alt="icon" className="w-[18px] h-[18px]"/>
                                        </div>
                                        <div>
                                            <p className="text-sm font-medium">Напишіть нам</p>
                                            <a href="mailto:tickets@ekonomika.ua" className="font-semibold text-[22px]" onClick={formatsEmailClick}>tickets@ekonomika.ua</a>
                                        </div>
                                    </div>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInRight" animateOnce={true}>
                                    <div className="flex gap-4 py-5 border-b-[1px] border-black lg:py-9">
                                        <div className="w-9 h-9 rounded-full flex items-center  justify-center flex-shrink-0
                                            bg-[linear-gradient(127deg,_#009064_0%,_#46a37e_50.41%,_#e6e47c_100%)]">
                                            <img  src={LocIcon} alt="icon" className="w-[18px] h-[18px]"/>
                                        </div>
                                        <div>
                                            <p className="text-sm font-medium">Локація</p>
                                            <p className="text-lg font-light text-[#6e6e6e]">Задля вашої безпеки місце проведення Business Wisdom Summit 2025 буде повідомлено учасникам напередодні заходу. Ми подбали про те, щоб створити максимально комфортні та безпечні умови.</p>
                                        </div>
                                    </div>
                                </ScrollAnimation>
                            </div>
                            <ScrollAnimation animateIn="animate__fadeInUp" animateOnce={true}>
                                <div className="md:order-1">
                                    <h2 className="text-3xl text-center font-bold uppercase mb-8 md:text-left
                                        lg:text-[42px] lg:mb-12 xl:text-[50px] leading-tight md:max-w-[460px]">БІЗНЕСИ СМІЛИВИХ 2026</h2>
                                    <p className="text-[#6e6e6e] text-lg text-center font-light md:text-left md:max-w-[410px]">Business Wisdom Summit – це не лише про знання, а й про визнання лідерів, які створюють Бізнеси сміливих. Будьте серед перших, хто дізнається, хто увійшов до списку найкращих керівників України за версією «ТОП-100. Рейтинги найбільших».</p>
                                </div>
                            </ScrollAnimation>
                        </div>

                    </div>


                </section>)) : ''
    )
}

export default Formats